import { ApiData } from "@cawita/core-front/api";
import { CwtModel } from "../modules/crud";
import { Partner } from "./partner.model";
import { User } from "./user.model";

export enum SenderType {
    User = 'user',
    Partner = 'partner'
}

@CwtModel({ name: 'up-message', path: '/up-message' })
export class UPMessage extends ApiData {
    _id?: string
    partner: Partner;
    sender: User;
    user: User;
    senderType: SenderType;
    // conversation: UPConversation;
    content: string;
    date: number;
    creationDate: number;

    fieldDictionary() {
        return {
            partner: Partner,
            user: User,
            sender: User
        };
    }
}
